// src/services/analysis/transactionAnalysis.ts

import { callOpenAI } from "../api/openaiApi";
import { Transaction, InitialAnalysisResult } from "../types/analysisTypes";

import { lf } from "../api/langfuse";

/**
 * Performs the initial analysis of a single bank transaction using OpenAI API.
 * @param transaction The bank transaction data.
 * @returns The detailed analysis extracted from OpenAI response.
 */
export async function analyzeSingleTransaction(transaction: Transaction): Promise<InitialAnalysisResult> {

    const promptSystem = await lf.getPrompt("transaction_extraction_text");
    const systemMessage = promptSystem.prompt;

      
    

    const prompt = `
Given the following bank transaction:
${JSON.stringify(transaction, null, 2)}
Please extract the information.
`;

    const messages: { role: "system" | "user" | "assistant"; content: string }[] = [
        { role: "system", content: systemMessage},
        { role: "user", content: prompt },
    ];

    // const content = await callOpenAI(messages);
    const content = await callOpenAI(messages, "gpt-5-mini", 1);
    console.log("OpenAI response InitialAnalysisResult:", content);

    try {
        return JSON.parse(content) as InitialAnalysisResult;
    } catch (error) {
        console.error("JSON parsing error in analyzeSingleTransaction:", error, content);
        throw new Error(`Failed to parse JSON: ${content}`);
    }
}
